import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Auth.css';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { t } = useLanguage();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        // Simulação de envio de email de recuperação
        try {
            // Aqui você implementaria a lógica real de recuperação de senha
            await new Promise(resolve => setTimeout(resolve, 2000)); // Simula delay

            setMessage(t('auth.forgotSuccess'));
        } catch (err) {
            setError(t('auth.forgotError'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <h1>{t('auth.forgotPassword')}</h1>
                    <p>{t('auth.forgotSubtitle')}</p>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {error && <div className="error-message">{error}</div>}
                    {message && <div className="success-message">{message}</div>}

                    <div className="form-group">
                        <label htmlFor="email">{t('auth.emailAddress')}</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder={t('auth.enterEmail')}
                        />
                    </div>

                    <button
                        type="submit"
                        className={`btn btn-primary btn-xl ${loading ? 'btn-loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? t('auth.sending') : t('auth.sendRecoveryEmail')}
                    </button>
                </form>

                <div className="auth-footer">
                    <p>{t('auth.rememberPassword')} <Link to="/login">{t('auth.loginHere')}</Link></p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;